function splitAppPath(value: string) {
  const suffixIndex = value.search(/[?#]/);
  const path = suffixIndex < 0 ? value : value.slice(0, suffixIndex);
  const suffix = suffixIndex < 0 ? '' : value.slice(suffixIndex);
  if (/^[a-z][a-z\d+.-]*:/i.test(path.trim())) {
    return { pathname: '/', suffix: '' };
  }
  // Always parse a single-leading-slash path, never a protocol-relative URL.
  const normalized = `/${path.replaceAll('\\', '/').replace(/^\/+/, '')}`;
  const pathname = new URL(normalized.replace(/\/{2,}/g, '/'), 'https://app.invalid')
    .pathname;
  return { pathname, suffix };
}

function appBasePath(baseUrl: string) {
  return splitAppPath(baseUrl).pathname.replace(/\/+$/, '');
}

export function toExternalAppPath(
  routerPath: string,
  baseUrl = import.meta.env.BASE_URL,
): string {
  const { pathname, suffix } = splitAppPath(routerPath);
  const base = appBasePath(baseUrl);
  if (!base || pathname === base || pathname.startsWith(`${base}/`)) {
    return `${pathname}${suffix}`;
  }
  return `${base}${pathname}${suffix}`;
}

export function toRouterPath(
  browserPath: string,
  baseUrl = import.meta.env.BASE_URL,
): string {
  const { pathname, suffix } = splitAppPath(browserPath);
  const base = appBasePath(baseUrl);
  if (!base) {
    return `${pathname}${suffix}`;
  }
  if (pathname === base) {
    return `/${suffix}`;
  }
  if (pathname.startsWith(`${base}/`)) {
    return `${pathname.slice(base.length)}${suffix}`;
  }
  // A browser location outside basename has no corresponding application route.
  return `/${suffix}`;
}
